import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import FundYieldManagementSection from "@/components/dashboard/funds-yields/sections/FundYieldManagementSection.vue";
import Component from 'vue-class-component'


@Component({
  components: {FundYieldManagementSection}
})
export default class FundYieldsComponent extends AfterFetchComponent {

}
